export const isServiceAccount = (name?: string): boolean => !!name && name.includes('@');
